import { Descriptions, Form, Input, Modal, Tag } from 'antd'
import { FC, useState } from 'react'

interface EligibilityOverrideModalProps {
  computedOutcome: boolean
  currentJustification: string | undefined
  onClose: () => void
  onSave: (outcome: boolean, justification: string) => void
  trueLabel: string
  falseLabel: string
  title: string
}

export const EligibilityOverrideModal: FC<EligibilityOverrideModalProps> = ({
  computedOutcome,
  currentJustification,
  onClose,
  onSave,
  trueLabel,
  falseLabel,
  title,
}) => {
  const [justification, setJustification] = useState(currentJustification ?? '')
  const overrideOutcome = !computedOutcome
  const trimmedJustification = justification.trim()
  const outcomeLabel = (value: boolean) => (value ? trueLabel : falseLabel)

  const save = () => {
    if (!trimmedJustification) return
    onSave(overrideOutcome, trimmedJustification)
    onClose()
  }

  return (
    <Modal
      open
      title={title}
      onCancel={onClose}
      onOk={save}
      okText='Apply override'
      okButtonProps={{ disabled: !trimmedJustification }}>
      <Form layout='vertical'>
        <Descriptions bordered column={1} size='small'>
          <Descriptions.Item label='System result'>
            <Tag color={computedOutcome ? 'success' : 'warning'}>
              {outcomeLabel(computedOutcome)}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label='Override to'>
            <Tag color={overrideOutcome ? 'success' : 'warning'}>
              {outcomeLabel(overrideOutcome)}
            </Tag>
          </Descriptions.Item>
        </Descriptions>
        <Form.Item
          label='Justification'
          required
          validateStatus={!trimmedJustification ? 'error' : ''}
          help={
            !trimmedJustification
              ? 'Explain why the system result should be overridden.'
              : undefined
          }
          style={{ marginTop: 24 }}>
          <Input.TextArea
            rows={4}
            value={justification}
            onChange={(event) => setJustification(event.target.value)}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
